import { TweenMax } from 'gsap';

export const Animation = {

init: function() {

        // Random number min-max - https://gist.github.com/timohausmann/4997906
        var randMinMax = function(t, n, a) {
          var r = t + Math.random() * (n - t)
          return a && (r = Math.round(r)), r
        }


        var logo = new TimelineMax();
        var logo_text = new TimelineMax();
        var logo_star = new TimelineMax();
        var scroll = new TimelineMax();
        var logo_small = new TimelineMax();
        var map = new TimelineMax();

        logo
        .set(['.hero_logo_container','.nav_list'], {visibility:"visible"})
        .add('f1', 0.4)
        .add('f2', 1)
        .from('.nav_list', 1, { autoAlpha:0, ease:Power0.easeNone}, 'f1')
        .fromTo('.logo-3', 0.6,  {drawSVG:"0%"}, {drawSVG:"100%", ease: Power1.easeInOut}, 'f1')
        .fromTo('.logo-4', 0.6,  {drawSVG:"0%"}, {drawSVG:"100%", ease: Power1.easeInOut}, 'f1')

        .fromTo('.logo-1', 0.6, {drawSVG:"0%"}, {drawSVG:"100%", ease: Power2.easeInOut}, 'f2')
        .fromTo('.logo-2', 0.6,  {drawSVG:"0%"}, {drawSVG:"100%", ease: Power1.easeInOut}, 'f2')


        logo_text
        .add('f1', 1.6)
        .to('.logo-text', 1, { autoAlpha:1, ease:Power0.easeNone}, 'f1')
        .to('.logo-text', 30, { transformOrigin:'center center', rotation: 360, ease: Power0.easeNone, repeat:-1} , 'f1')

        logo_star
        .add('f1', 2)
        .from('.logo-star-container', 0.4, { transformOrigin:'center center', autoAlpha:0, rotation: 180, scale:(0), ease: Power2.easeOut,}, 'f1')
        .from('.logo-star-container', 6, { rotation: 360, repeat:-1, ease: Power0.easeNone }, 'f1+0.4')

        scroll
        .add('f1', 2)
        .from(['.scroll-1', '.scroll-2'], 0.6,  {autoAlpha:0, ease: Power0.easeNone}, 'f1')
        .fromTo('.scroll-1', 0.6,  {drawSVG:"0%"}, {drawSVG:"100%", ease: Power0.easeNone, repeat: -1, repeatDelay: 4}, 'f1+2')

        logo_small
        .add('f1', 0)
        .to('.logo-small-2', 20, { transformOrigin:'center center', rotation: 360, ease: Power0.easeNone, repeat:-1} , 'f1')

        map
        .add('f1', 0)
        .from(['.o-map'], 0.6,  {autoAlpha:0, ease: Power1.easeInOut}, 'f1')
        .fromTo('.o-map *', 0.6,  {drawSVG:"0%"}, {drawSVG:"100%", ease: Power1.easeInOut}, 'f1')

        // init controller
        var controller = new ScrollMagic.Controller();

        //// prawn

        // build tween
            var prawn = new TimelineMax()

            prawn
            .add('f1', 0)

            .fromTo('.prawn-2', 0.9,  {drawSVG:"0%"}, {drawSVG:"100%", ease: Power1.easeInOut}, 'f1')
            .fromTo('.prawn-1', 0.5,  {drawSVG:"0%"}, {drawSVG:"100%", ease: Power1.easeInOut}, 'f1+=0.6')

        // build scene
        var scene1 = new ScrollMagic.Scene({triggerElement: '#about', offset: 0, tweenChanges: true, reverse: false})
            .setTween(prawn)
            // .addIndicators()
            .addTo(controller);


        //// bowl

        // build tween
            var bowl = new TimelineMax()

            bowl
            .add('f1', 0)

            bowl
            .fromTo('.bowl-1', 0.6, {drawSVG:"0%"}, {drawSVG:"100%", ease: Power2.easeInOut}, 'f1')
            .fromTo('.bowl-2', 0.6,  {drawSVG:"0%"}, {drawSVG:"100%", ease: Power1.easeInOut}, 'f1+=0.6')
            .fromTo('.bowl-0', 1, {drawSVG:"0%"}, {drawSVG:"100%", ease:Power1.easeOut}, 'f1+=1')
            .fromTo('.bowl-3', 1, {drawSVG:"0%"}, {drawSVG:"100%", ease:Power1.easeOut}, 'f1+=1')

        // build scene
        var scene1 = new ScrollMagic.Scene({triggerElement: '#menu', offset: 0, tweenChanges: true, reverse: false})
            .setTween(bowl)
            // .addIndicators()
            .addTo(controller);


        //// tree

        // build tween
            var tree = new TimelineMax()

            tree
            .add('f1', 0)

            tree
            .fromTo('.tree-1', 1.2, {drawSVG:"0%"}, {drawSVG:"100%", ease: Power2.easeInOut}, 'f1')
            .fromTo('.tree-2', 0.8,  {drawSVG:"0%"}, {drawSVG:"100%", ease: Power1.easeInOut}, 'f1+=0.4')

        // build scene
        var scene1 = new ScrollMagic.Scene({triggerElement: '#contact', offset: 0, tweenChanges: true, reverse: false})
            .setTween(tree)
            // .addIndicators()
            .addTo(controller);



        //// text

        // build tween
            var menuitems = new TimelineMax()

            menuitems
            .add('f1', 0)

            menuitems
            .to('.nav_item', 0.6, {color:"#e60101", ease: Power2.easeInOut}, 'f1')

        // build scene
        var scene1 = new ScrollMagic.Scene({triggerElement: '#menu', offset: 0, tweenChanges: true, reverse: true})
            .setTween(menuitems)
            // .addIndicators()
            .addTo(controller);

        // map

        // build scene
        var scene1 = new ScrollMagic.Scene({triggerElement: '#map', offset: -200, tweenChanges: true, reverse: true})
            .setTween(map)
            // .addIndicators()
            .addTo(controller);
    },

};

Animation.init();



// WEBPACK FOOTER //
// ./src/_assets/js/modules/animation.js